<div class="form-group">
    <label for="mcasURL">{{'SERVICE-MCAS.URL' | translate}}</label>
    <input type="text" class="form-control" id="mcasURL" [(ngModel)]="service['mcasURL']" name="mcasURL" #mcasURL="ngModel">
</div>

<div class="form-group">
    <label for="mcasUsr">{{'SERVICE-MCAS.USERNAME' | translate}}</label>
    <input type="text" class="form-control" id="mcasUsr" [(ngModel)]="service['mcasUsr']" name="mcasUsr" #mcasUsr="ngModel">

</div>

<div class="form-group">
    <label for="mcasPwd">{{'SERVICE-MCAS.PASSWORD' | translate}}</label>
    <input type="password" class="form-control" id="mcasPwd" [(ngModel)]="service['mcasPwd']" name="mcasPwd" #mcasPwd="ngModel">
</div>